import { getAuthHeaders } from "@/shared/api/authHeaders";
import { keysToSnakeCase } from "@/shared/lib/case";
// This file is generated by generate-entities.ts. Please DO NOT edit this file directly.
import type { QueryOptions } from "@/shared/lib/tanstack-query";
import {
  type UseQueryResult,
  useQueries,
  useQuery,
} from "@tanstack/react-query";
import { FreightMatching } from "@x-mile/api-contract";
import type { GetOffersCargoParams } from "../model";

export const useGetOffersCargo = (
  params: GetOffersCargoParams,
  options?: QueryOptions<typeof FreightMatching.useGetOffersCargo>,
): UseQueryResult<FreightMatching.GetOffersCargoQueryResult, undefined> => {
  const authHeaders = getAuthHeaders();
  const result = useQuery({
    ...options,
    queryKey: ["getOffersCargo", keysToSnakeCase(params)],
    queryFn: () =>
      FreightMatching.getOffersCargo(
        params.id,
        // バックエンド（rails）ではキーがスネークケースになっているため、クエリパラメータをスネークケースに変換する

        {
          headers: authHeaders.isOk() ? authHeaders.value : {},
        },
      ),
  });
  return result as UseQueryResult<
    FreightMatching.GetOffersCargoQueryResult,
    undefined
  >;
};

export const useMultipleGetOffersCargo = (
  paramsList: { [key: string | number]: GetOffersCargoParams },
  options?: QueryOptions<typeof FreightMatching.useGetOffersCargo> & {
    sortFunc?: (a: GetOffersCargoParams, b: GetOffersCargoParams) => number;
  },
): {
  [key: string | number]: UseQueryResult<
    FreightMatching.GetOffersCargoQueryResult,
    undefined
  >;
} => {
  const authHeaders = getAuthHeaders();
  const keys = Object.keys(paramsList);
  const sortedKeys = options?.sortFunc
    ? keys.sort((a, b) =>
        options?.sortFunc ? options.sortFunc(paramsList[a], paramsList[b]) : 0,
      )
    : keys;
  const result = useQueries({
    queries: sortedKeys.map((key) => {
      const params = paramsList[key];
      return {
        ...options,
        queryKey: ["getOffersCargo", keysToSnakeCase(params)],
        queryFn: () =>
          FreightMatching.getOffersCargo(
            params.id,
            // バックエンド（rails）ではキーがスネークケースになっているため、クエリパラメータをスネークケースに変換する

            {
              headers: authHeaders.isOk() ? authHeaders.value : {},
            },
          ),
      };
    }),
  });
  const resultByKeys = Object.fromEntries(
    keys.map((key, i) => [key, result[i]]),
  );
  return resultByKeys as {
    [key: string | number]: UseQueryResult<
      FreightMatching.GetOffersCargoQueryResult,
      undefined
    >;
  };
};

// TODO: api-contract側でmockを生成しないことになったので、自前でmockを生成する
// export const useGetOffersCargoMock = (
//   params: GetOffersCargoParams,
//   options?: QueryOptions<typeof FreightMatching.useGetOffersCargo>,
// ) => {
//   const [workerStarted, setWorkerStarted] = useState(false);
//   void (async () => {
//     if (!workerStarted) {
//       await FreightMatching.startMockServerWoker(
//         FreightMatching.getGetOffersCargoMockHandler(),
//       );
//       setWorkerStarted(true);
//     }
//   })();
//   return useGetOffersCargo(params, {
//     enabled: workerStarted && options?.enabled,
//   });
// };

// export const useMultipleGetOffersCargoMock = (
//   paramsList: { [key: string | number]: GetOffersCargoParams },
//   options?: QueryOptions<typeof FreightMatching.useGetOffersCargo>,
// ) => {
//   const [workerStarted, setWorkerStarted] = useState(false);
//   void (async () => {
//     if (!workerStarted) {
//       await FreightMatching.startMockServerWoker(
//         FreightMatching.getGetOffersCargoMockHandler(),
//       );
//       setWorkerStarted(true);
//     }
//   })();
//   return useMultipleGetOffersCargo(paramsList, {
//     enabled: workerStarted && options?.enabled,
//   });
// };
